export const calcDevelopment = (roastingTime: number, timeToFirstCrack: number) => {
  return (roastingTime - timeToFirstCrack) / roastingTime;
};

export const calculatePPPT = (initialWeight: number, roastedWeight: number) =>
  ((initialWeight - roastedWeight) / initialWeight) * 100;
